<template>
  <transition name="dropdown">
    <div
      v-if="open"
      class="absolute right-0 top-[calc(100%+12px)] w-96 max-w-[calc(100vw-1rem)] overflow-hidden rounded-theme-md
        z-50 border border-theme-border bg-theme-surface shadow-theme-dialog"
      data-test="notification-dropdown"
    >
      <div
        class="flex items-center justify-between gap-3 border-b border-theme-border px-4 py-3"
      >
        <h3 class="text-sm font-semibold text-theme-text">
          {{ $t('notifications.common.title') }}
        </h3>
        <div class="flex items-center gap-3">
          <AppButton
            v-if="unreadCount > 0"
            type="button"
            variant="link"
            tone="primary"
            size="xs"
            data-test="notification-mark-all-read"
            @click="$emit('mark-all-read')"
          >
            {{ $t('notifications.common.mark_all_read') }}
          </AppButton>
          <AppButton
            to="/notifications/preferences"
            variant="ghost"
            tone="neutral"
            size="xs"
            icon-only
            :icon="mdiCogOutline"
            :title="$t('notifications.common.preferences')"
            :aria-label="$t('notifications.common.preferences')"
            @click="$emit('close')"
          />
        </div>
      </div>

      <div class="max-h-96 overflow-y-auto">
        <!--
          The unread counter (Redis) updates a moment before the ES list
          query becomes consistent on the read replica, so right after a
          push arrives we can briefly have `unreadCount > 0` while
          `items.length === 0`. Showing "Geen notificaties" in that
          window looks like a bug to the user (badge=1, list=empty).
          Treat that state as still-loading instead, so the empty copy
          only renders when the count *and* the list both say nothing.
        -->
        <div
          v-if="loading && items.length === 0"
          class="px-4 py-6 text-center text-sm text-theme-text-muted"
        >
          {{ $t('notifications.common.loading') }}
        </div>
        <div
          v-else-if="items.length === 0"
          class="px-4 py-8 text-center text-sm text-theme-text-muted"
          data-test="notification-empty"
        >
          {{ $t('notifications.common.empty') }}
        </div>
        <NotificationItem
          v-for="n in items"
          :key="n.id"
          :notification="n"
          @mark-read="$emit('mark-read', $event)"
          @delete="$emit('delete', $event)"
          @cta-click="$emit('cta-click', $event)"
        />
      </div>

      <div class="border-t border-theme-border px-4 py-2 text-center">
        <AppButton
          to="/notifications"
          variant="link"
          tone="primary"
          size="xs"
          @click="$emit('close')"
        >
          {{ $t('notifications.common.view_all') }}
        </AppButton>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mdiCogOutline } from '@mdi/js';
import { defineComponent } from 'vue';

  import AppButton from '@/components/ui/buttons/AppButton.vue';
import NotificationItem from './NotificationItem.vue';

  export default defineComponent({
    name: 'NotificationDropdown',
    components: { AppButton, NotificationItem },
    props: {
      open: { type: Boolean, default: false },
      items: { type: Array, default: () => [] },
      unreadCount: { type: Number, default: 0 },
      loading: { type: Boolean, default: false },
    },
    emits: ['close', 'mark-read', 'mark-all-read', 'delete', 'cta-click'],
    setup() {
      return { mdiCogOutline };
    },
  });
</script>
